import React from 'react';
import SolutionRentalWaitContainer from 'containers/SolutionRentalWaitContainer';

export default function SolutionRentalWaitPage() {
  return (
    <SolutionRentalWaitContainer />
  )
}
